import "./index.css";

export default function Banner() {
  return (
    <div className="banner">
      <div className="gameFooterBanner">
        Love Mathler?{" "}
        <a
          id="action-link"
          target="_blank"
          rel="noreferrer"
          href="https://crosswordle.com/"
        >
          Play Crosswordle
        </a>
      </div>
    </div>
  );
}
